import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Nexus } from '@tomandco/nexus-api-types';
import { ProductPriceComponentDef } from '@df/ui/price/product-price.component.def';
@Component({
    selector: 'product-price',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    template: '<span [innerHTML]="getHtml()"></span>'
})
export class ProductPriceComponent extends ProductPriceComponentDef {
    @Input()
    request?: Omit<Nexus.Lib.Basket.BasketRequestData, 'id'>;
    protected override update(): void {
        this.value = this.product
            ? this.orgPrice
                ? this.product.getOrgPrice(this.request)
                : this.product.getPrice(this.request)
            : undefined;
        this.detectChanges();
    }
}
